import {has} from 'external/lodash'
import create from 'utils/command'
import {reduceByKey, accumulateByKey} from 'utils/functions' 

const hooks =  [
  {paths: ['props/params/pageName', 'props/params/groupId'], resolves: [fetchUnits]},
  {paths: ['props/params/groupId', 'props/params/unitId'], resolves: [fetchUnitLessons]}
]

export {hooks as default}

export async function  fetchSubjectsAndGrades({state, update}) {
  const shouldFetch = (state.subjects == undefined) || (state.grades == undefined)
  if (shouldFetch) {
    const [subjects, grades] = await Promise.all([
      create('public', 'subjects')().then(reduceByKey('id')),
      create('catalog', 'grades')().then(reduceByKey('id'))
    ])
    update({subjects: {$set: subjects}, grades: {$set: grades}})
  }
}

export async function fetchUnits({state, update}, opt){
  const {groupId, section, pageName} = state.props.params
  const navigation = state.props.navigation
  const {path} = opt

  if (pageName != 'my-courses') return 
  if (!groupId) return

  const initializingFromLessons = navigation.units.active && path == undefined


  if (section != 'units' && !initializingFromLessons) return

//  console.log(opt, state, diff, `${initializingFromLessons} GroupId: ${groupId}, PageName: ${pageName}, Section: ${section}, Navigation: ${navigation.units.active}, Path: ${path}`)

  const units = await create('student', 'units')({groupId})
  update({units: {$set: units}, unitsCourse: {$set: groupId}})

}

export  async function fetchUnitLessons({state, update}, opt) {
  const {groupId, unitId, pageName} = state.props.params
  if (pageName != 'my-courses' || !groupId || !unitId) return
  if (state.unitLessons && state.unitLessons[groupId] && state.unitLessons[groupId][unitId]) return
  const [{lessons, content}] = await create('student', 'unitLessons')({groupId, unitId})
  const unitLessons = {course: groupId, lessons, content: accumulateByKey('id', true)(content)}
  update({unitLessons: {$auto: {[unitId]: {$set: unitLessons}}}})
}
